import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import Axios from "axios";
import Cookies from "universal-cookie";
import uuid from "react-uuid";
import Container from "../components-layout/Container";
import Layout from "../Layout";
import WarningModal from "../components-modals/WarningModal";
import DatagridItemsBodega from "./bodegas/DatagridItemsBodega";
import Pagination from "../components-contabilidad-analisis/Pagination";
import ResumenProductos from "./bodegas/ResumenProductos";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";
import FacturacionForm from "./facturacion/FacturacionForm";
import SubmitButton from "./facturacion/SubmitButton";
import Pago from "./facturacion/Pago";
import { Form, Formik } from "formik";
import { object, string, number } from "yup"; 
import Header from "../components-layout/Header";
import { DocumentPlusIcon } from "@heroicons/react/24/outline";
import BusquedaAlumnosModal from "./BusquedaAlumnosModal";
import { retrieveData } from "../../helpers/helpers";
import OtherWarehousesModal from "./facturacion/OtherWarehousesModal";
import { scrollComponent } from "../tools/scrollComponent";
import { fetchApi } from "../tools";

const searchParams = [
  "IdProducto",
  "Descripcion",
  "Descripcion_Corta",
  "Imagen",
  "IdTipo",
  "Tipo",
  "IdCategoria",
  "Categoria",
  "IdProveedor",
  "Proveedor",
  "Costo",
  "Precio",
  "Existencia",
  "Inventario",
  "FacRapida",
  "Pedido",
  "Activo",
];
let runInit = true;

const Facturacion = () => {
  const topRef = useRef(null)
  const pagoRef = useRef(null)

  
const user = useSelector((state) => state.auth.user);
const userObj = JSON.parse(user);

const cookies = new Cookies();
//const urlInvoiceApi = cookies.get("__urlInvoiceApi");

const urlState = useSelector(state => state.url.urlInvoiceApi)
const urlInvoiceApi = urlState === '' || urlState === undefined || urlState === null ? cookies.get("__urlInvoiceApi") : urlState

const url = urlInvoiceApi + "/utils/busquedas";
const headers = useSelector((state) => state.url.headersAPI);
const IdEmp = useSelector((state) => state.auth.IdEmp);

const [loading, setLoading] = useState(false);
const [rawData, setRawData] = useState([]);
const [enableVoucher, setEnableVoucher] = useState(false);
const [mensaje, setMensaje] = useState(false)

const [centro, setCentro] = useState(0)
const [botonesDescripcion, setBotonesDescripcion] = useState(false)
const [validadorTarjeta, setValidadorTarjeta] = useState(false)
  
const [otherWarehouses, setOtherWarehouses] = useState([]);
const [showOtherWarehousesModal, setShowOtherWarehousesModal] = useState(false);
const [productoSeleccionado, setProductoSeleccionado] = useState()

const bodegas = useSelector((state) => state.auth.bodegas);
const [filterData, setFilter] = useState([]);
const primerIdBodega = bodegas[0].IdBodega;
const [idBodega, setIdBodega] = useState(0);
const [currentPage, setCurrentPage] = useState(1)
const recordsPerPage = 10

const indexOfLastRecord = currentPage * recordsPerPage
const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
const [productos, setProducto] = useState([]);
const currentRecords = filterData?.slice(indexOfFirstRecord, indexOfLastRecord);
const [errorDuplicado, setErrorDuplicado] = useState(false)
const [valuesToResend, setValuesToResend] = useState()
const [errorsToResend, setErrorsToResend] = useState()

const [showSearchModal, setShowSearchModal] = useState(false);
const [query, setQuery] = useState("");
const [modal, setModal] = useState({
    show: false,
    msg: "",
    ok: false,
});

const handleQuery = (e, query) => {
    e.preventDefault();
    doSearch(query.trim());
    setCurrentPage(1);
}
  
const doSearch = (query) => {
  if (query === null) {
      setFilter(rawData)
  } else {
      setFilter(rawData.length > 0 && rawData?.filter((x) => {
          return searchParams?.some((y) => {
              return x[y]?.toString()?.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
      }))
  }
}

const nPages = Math.ceil(filterData?.length / recordsPerPage)
const intermediario = (flagCentro, producto) => {
    setProductoSeleccionado(producto)
    if(!flagCentro){
      setBotonesDescripcion(() => false)
      addProduct(producto)
    }else{
      setBotonesDescripcion(() => true)
      setMensaje(() => {return false})
      setModal({
        show: true,
        ok: false,
        msg: `Deseas cambiar la descripción al producto ${producto.Descripcion}?`
      })
    }
}
  
const enviarModificado = (nuevaDescripcion) => {
    if(!nuevaDescripcion){
      addProduct(productoSeleccionado)  
    }else{
      productoSeleccionado.Descripcion = nuevaDescripcion
      addProduct(productoSeleccionado)
    }
}
  
const addProduct = async (producto) => {

    try {
      let {
        Existencia,
        Unidades,
        Unidad = 1,
        IdProducto,
        Inventario,
      } = producto;
      
      if (Existencia < 1 && Inventario) {
        const res = await retrieveData({
          url,
          headers,
          method: "GET",
          payload: {
            opcion: "PRODUCTOSGRAL",
            IdProducto,
          },
        });
        const { msg } = res
        const otherWarehousesWithProductArr = msg;
        if (otherWarehousesWithProductArr.length === 0) {
          setMensaje(() => {return true})
          throw new Error("Sin existencias en todas las bodegas");
        }
        
        setOtherWarehouses(otherWarehousesWithProductArr);
        return setShowOtherWarehousesModal(true);
      }

      if (Unidades) {
          Unidad = Unidades[0].Unidad;
      }
      
      const isDuplicated =
      productos.findIndex(
        (prod) => prod.IdProducto === producto.IdProducto
      ) !== -1
      ? true
          : false;
          
      if (!isDuplicated) {
        const id = uuid();
        
        setProducto((curr) => [...curr, { ...producto, id, qty: 1, Unidad }]);
      }else{
        throw new Error("El producto ya ha sido seleccionado")
      }
    } catch (err) {
      setMensaje(() => {return true}) // para que no muestre los botones no sí
      return setModal({
        msg: err.message,
        ok: false,
        show: true,
      });
    }
}

const updateProducto = (producto, prop = "", payload = "") => {
    const { id, Existencia } = producto;
    const indexOfId = productos.findIndex((producto) => producto.id === id);
    
    if (["qty","Unidad"].includes(prop)) {
       setProducto((curr) => {
        if (payload >= 0 && payload <= Existencia) {
          curr[indexOfId][prop] = payload;
        }
        return [...curr];
      });
    }
    
    if (["Descripcion","Precio"].includes(prop)) {
       setProducto((curr) => {
        curr[indexOfId][prop] = payload;
        
        return [...curr];
      });
    }
}
  
const delProducto = (producto) => {
    const { id } = producto;
    const newProductos = productos.filter((prod) => prod.id !== id);
    setProducto(newProductos);
};
  
const fetchDataPost = async (datos) => {
  let mensaje = null
  const d = JSON.parse(datos)
  if(d.Centro === 0 ){
    setMensaje(()=> {return true})
    setLoading(true);
    try {
      const res = await fetchApi({
        method: "POST",
        url: urlInvoiceApi + "/inventario/facturas",
        headers,
        content:d,
      });
      mensaje = res;
      //const { data } = res.response
      //const { Error: err, Mensaje } = res.msg;
      
      //if (err !== 0) {
      //  throw new Error(Mensaje);
      //}
      setLoading(false);
      setMensaje(() => {return true})
      if(res.msg.Error === 0){
        setModal({
          show: true,
          ok: true,
          reload: true,
          msg: res.msg.Mensaje
        });
      }else{

      
      if(res.msg[0].Error !== "0"){
            try {
                setLoading(false); // no estaba
                const msgErr = res.msg[0].Mensaje
                const msgCargos = res.msg[0].CargosAPagar
                const msgPendiente = res.msg[0].CargosPendientes
                setErrorDuplicado(true)
                setModal({
                  show: true,
                  ok:     false,
                  reload: true,
                  msg: [
                    msgErr,
                     "Estás intentando facturar \n",
                     msgCargos.map(e => e.Descripcion),
                     "ya tienes facturado el día de hoy: \n",
                     msgPendiente.map(e => e.Descripcion)
                  ]
                });
                //handleValidar(true, true, { ok: true, show: true, msg: msgErr})
            } catch (error) {
                setModal({
                    show: true,
                    ok:     false,
                    reload: true,
                    msg: res.msg[0].Mensaje//, por pago pendiente: ${msgPendiente}
                });
                  //handleValidar(true, true, { ok: true, show: true, msg: res.msg[0].Mensaje})
            }
      }else{ // mensaje si exitoso
            setErrorDuplicado(false)
            setLoading(false)
            setModal({
                show: true,
                ok: true,
                reload: true,
                msg: res.msg.Mensaje
            });
      }
    }
    } catch (err) {
      setLoading(false);
      setErrorDuplicado(false)
      console.log(err)
      //const { data } = err.response
      //const msg = data.msg.Mensaje
      setModal({
        ok: false,
        msg: err.response.data.msg.Mensaje, //temp1.response.data.msg.Mensaje
        show: true,
        reload: true,
      });
    }
  }else{
    setModal({
      ok: false,
      msg: "La factura no es para centro, intentelo de nuevo",
      show: true,
      reload: true,
    });
  }
};



const arreglarArr = (eParams) => {
    return eParams.split(";").map(e => {
        if(e.length > 0){
            return e
        }    
    }).filter(e=> e).join(";")
}

const formatoError = (input) => {
  const salidas = {
    "Nit" :       "Nit" ,
    "NombreDoc" : "Nombre" ,
    "Cel" :       "Celular",
    "Direccion" : "Direccion" ,
    "Email1" :    "Correo electrónico" ,
    "apellidos" : "Apellidos" ,
    "nombres" :   "Nombres" ,
    "code" :      "Código CVC" ,
    "direccion" : "Dirección",
    "mmyy" :      "mes y año MM / YY" ,
    "number" :    "Número de la tarjeta" ,
    "email" :     "Correo electrónico" ,
  }
  return salidas[input] || input
}

const hayMontosIngresados = (values) => {
  return !values.efectivo && !values.tarjeta
}

const handleSubmit = (values, errors, e) => {

  e.preventDefault();
  if(values === undefined){
    values = valuesToResend
    values.Reenviado = 1
  }else{
    values.Reenviado = 0
  }
  if(errors === undefined){
    errors = errorsToResend
  }

  if(!errorDuplicado){
    setValuesToResend(values);
    setErrorsToResend(errors);
  }
  const labelError = Object.values(errors).length > 0 && Object.entries(errors)[0][1];
  const valueError = Object.values(errors).length > 0 && Object.entries(errors)[0][0];
  try {
    if(!Object.values(errors).length > 0) {
      values.Email = arreglarArr(`${values.Email1};${values.Email2};${values.Email3}`)
      delete values.Email1
      delete values.Email2
      delete values.Email3
    }else{
      throw new Error(`{"mensaje":  "${labelError}: ${formatoError(valueError)}", "campo": "${formatoError(valueError)}"}`)
    }
    if(Object.keys(errors).length > 0 ) { // 23 es el numero de keys de values actualmente, puede varirar en el futuro, el evento tiene 33 keys
      // el error es un error del formulario
      throw new Error(`{"mensaje":  "${labelError}: ${formatoError(valueError)}", "campo": "${formatoError(valueError)}"}`)
    }else{
      if(hayMontosIngresados(values)){
        throw new Error(`{"mensaje":  "Ingrese el total a pagar"}`)
      }else{
        // if (!/\d{7}/.test(values.Cel)) {
        //   throw new Error(`{"mensaje":  "Ingrese un número de celular de 8 dígitos"}`)
        // }
        const d = new Date().toLocaleDateString("es-GT");
        const fecha = d.split("/").reverse().map((x) => x.padStart(2, "0")).join("");
        
        let {
          mmyy,
          efectivo,
          tarjeta,
          noBoleta,
          fechaBoleta,
          monto,
          Nit,
          Direccion,
          ...resto
        } = values;
        let voucher = enableVoucher ? values.voucher : null;
        let [mes, year] = mmyy.split("/");
        year = year ? "20" + year : "";
        
        if (productos.length === 0) {
          setMensaje(() => {return true})
          throw new Error(`{"mensaje":  "Seleccione al menos un producto"}`)
        }
        
        //Revisar si todos los productos llevan cantidad valida
        if (productos.some((producto) => producto.qty === 0)) {
          setMensaje(() => {return true})
          throw new Error(`{"mensaje":  "Ingrese la cantidad en todos los productos"}`)
        }
        
        if (monto >= 2500 && Nit === "CF") {
          setMensaje(() => {return true})
          throw new Error(`{"mensaje":  "Para montos mayores a Q2500.00 no se puede facturar con CF."}`)
        }
        
        //Revisar subtotal
        const subtotal = enableVoucher
        ? Number(efectivo) + Number(tarjeta) + Number(voucher)
        : Number(efectivo) + Number(tarjeta);
        
        if (monto !== subtotal) {
          setMensaje(() => {return true})
          throw new Error(`{"mensaje":  "Revisar formas de pago. Subtotal no coincide con total."}`)
        }
        
        //Formateo de formas de pago
        const FormasPago = fomatearFormasPago(
          efectivo,
          tarjeta,
          fecha,
          voucher,
          noBoleta,
          fechaBoleta
        );
        
        //Formateo de productos seleccionados
        const DetalleProductos = productos.map(
          ({
            IdBodega,
            IdProducto,
            qty,
            Unidad,
            Descripcion,
            Precio,
            Consignacion,
          }) => ({
            Descripcion,
            Precio,
            Consignacion: Consignacion ? 1 : 0,
            IdProducto,
            IdBodega: !IdBodega ? values.IdBodega : IdBodega,
            Cantidad: qty,
            Unidad,
          })
        );
        
        const data = JSON.stringify({
          ...resto,
          Nit,
          Direccion: Direccion.length > 200 ? Direccion.slice(0, 200) : Direccion,
          monto,
          mes,
          year,
          Canal: 4,
          FormasPago,
          DetalleProductos,
          IdEmp,
          HostName: "DEV07",
          IpHost: "131.107.1.235",
          OS: "Windows",
        });
        
        fetchDataPost(data);
      }
    }

  } catch (error) {
    const jsonerror = JSON.parse(error.message)
    const { mensaje, campo } = jsonerror
    if(campo){
      if(['Nit', 'NombreDoc', 'Cel', 'Direccion', 'Email1'].includes(campo)){
        scrollComponent(topRef.current)
     }else{
        scrollComponent(pagoRef.current)
     }
    }
    setModal({
      ok: false,
      show: true,
      msg: ` ${mensaje}`,
    });
  }
}
 
useEffect(() => {
  if(idBodega !== 0){
    manager(fetchDataProductos(idBodega))
  }
}, [idBodega])

const fetchDataProductos = async (bodegaParam) => {
  try {
    const res = await Axios({
      method: "GET",
      url,
      headers,
      params: {
        opcion: "PRODUCTOS",
        IdBodega: bodegaParam,
        Centro: 0,
      },
    });
    const { data } = res
    setRawData(() => data.msg);
    if (data.msg.length > 0) setEnableVoucher(data.msg[0].Voucher);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    setModal({
      ok:false,
      show:true,
      msg:"Error en la comunicación"
    })
    console.log(err);
  }
}
useEffect(() => {
  function handleScroll(event) {
    if (document.activeElement.type === "number") {
      event.target.blur();
    }
  }
  setIdBodega(primerIdBodega)
  window.addEventListener("wheel", handleScroll);
  return () => {
    window.removeEventListener("wheel", handleScroll)
  };
}, []);
useEffect(() => {
  setTimeout(() => scrollComponent(topRef.current) ,500)
}, [])


useEffect(() => { 
  setFilter(rawData) 
}, [rawData])
 
  return (
    <Layout userObj={userObj} activeTab={["Facturación", "Generar Factura C&M"]}>
      <WarningModal
        width=" w-[70%] "
        facturacion={true}
        open={loading ? true : false}
        image={<img src="./img/loader.gif" alt="loading" />}
        opacity="bg-opacity-100"
      />

      <WarningModal
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          )
        }
        title="Aviso"
        subtitle=
          {Array.isArray(modal.msg) ?
            (
              <div className='flex flex-col'>
                <div className="text-md text-grisMira">{`${modal.msg[0]}\n `}</div>
                <div className="text-md text-grisMira">{`${modal.msg[1]}\n `}</div>
                <ul className='flex flex-col mt-2 list-disc pl-6'>
                  {modal.msg[2].map(cargo => (
                    <li className="text-md text-grisMira">{` ${cargo}\n `}</li>
                  )
                  )}
                </ul>
                <div className="text-md text-grisMira">{` ${modal.msg[3]} `}</div>
                  <ul className='flex flex-col mt-2 list-disc pl-6'>
                    {modal.msg[4].map(pendiente => (
                          <li className="text-md text-grisMira">{` ${pendiente}\n `}</li>)
                    )}
                  </ul>
              </div>
              )
            :
            <span className="text-md text-grisMira">{modal.msg}</span>
      }
        opacity="bg-opacity-50"
        >
        <div className="mt-5 sm:mt-6">
        {errorDuplicado ?
            <div className="flex flex-row gap-4 justify-between">
              <button
              onClick={() => {
                    if (modal.reload) {
                      window.location.reload();
                    }
                    setModal((curr) => ({
                        ...curr,
                        show: false,
                        reload: false,
                    }));
                }}
                type="button"
                className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                >
              No
              </button>
              <button
              onClick={(e) => manager(handleSubmit(undefined, undefined, e))}
                type="button"
                className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                >
              Sí
              </button>
            </div>
            :
              <button
              onClick={() => {
                if (modal.reload) {
                  window.location.reload();
                }
                setModal((curr) => ({
                  ...curr,
                  show: false,
                  reload: false,
                }));
              }}
              type="button"
              className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
              >
              Entendido
              </button>
        }
        </div>
      </WarningModal>
      <div>

      
      <OtherWarehousesModal
        setShowForm={setShowOtherWarehousesModal}
        showForm={showOtherWarehousesModal}
        data={otherWarehouses}
        url={urlInvoiceApi}
        headers={headers}
        addProduct={addProduct}
      />

      <Container height="h-full">
        <Formik
          validateOnBlur={true}
          validateOnChange={true}
          initialValues={{
            //Campos de la factura
            Carnet: "",
            Alumno: "",
            IdBodega: primerIdBodega,
            Nit: "",
            NombreDoc: "",
            Centro:0,
            Direccion: "",
            Cel: "",
            //Email: "",
            Email1: "",
            Email2: "",
            Email3: "",
            //Campos solo necesarios si se cancela con tarjeta de crédito
            number: "",
            mmyy: "",
            code: "",
            nombres: "",
            apellidos: "",
            direccion: "",
            pais: "",
            email: "",
            //Campos solo necesarios si se cancela con voucher
            noBoleta: "",
            fechaBoleta: "",
            //Campo requeridos para realizar pago
            monto: "",
            efectivo: 0,
            tarjeta: 0,
            voucher: 0,
          }}
          validationSchema={object({
            Nit: string().required("Dato obligatorio"),
            NombreDoc: string().when("Nit", {
              is: "CF",
              then: (schema) => schema,
              otherwise: (schema) => schema.required("Dato obligatorio"),
            }),
            Cel:       string().max(8, "El número no debe ser de más de 8 dígitos").required("Dato obligatorio"),
            Email1:    string().email('correo inválido').required("Dato obligatorio"),
            Direccion: string().required("Dato obligatorio"),
            efectivo:  number().required("Dato obligatorio"),
            tarjeta:   number().required("Dato obligatorio"),
            //
            number:      validadorTarjeta ? string().required("Dato obligatorio"): null,
            mmyy:        validadorTarjeta ? string().required("Dato obligatorio"): null,
            code:        validadorTarjeta ? string().required("Dato obligatorio"): null,
            email:       validadorTarjeta ? string().email("correo inválido").required("Dato obligatorio"): null,
            direccion:   validadorTarjeta ? string().required("Dato obligatorio"): null,
            nombres:     validadorTarjeta ? string().required("Dato obligatorio"): null,
            apellidos:   validadorTarjeta ? string().required("Dato obligatorio"): null,
          })}
          //onSubmit={(values) => eventManager(handleSubmit(values))}
        >
          {({ values, setFieldValue, resetForm, errors, touched }) => {
            
            return (
              <div ref={topRef}>
              <Form>
                <BusquedaAlumnosModal
                  setShowForm={setShowSearchModal}
                  showForm={showSearchModal}
                  url={url}
                  headers={headers}
                  setModal={setModal}
                  setFieldValue={setFieldValue}
                  values={values}
                />
                <Header title="Generar factura C&M" logo={DocumentPlusIcon} />
                <div className="grid grid-cols-1 2xl:grid-cols-2 gap-5 2xl:gap-x-5 2xl:gap-y-0">
                  <div className="order-1 bg-primarioMira shadow-2xl rounded-lg 2xl:rounded-b-none 2xl:rounded-t-lg border-b-0 2xl:border-b border-b-grisMira">
                    <FacturacionForm
                      url={urlInvoiceApi}
                      errorDuplicado={errorDuplicado}
                      url2={url}
                      centro={0}
                      setCentro={setCentro}
                      headers={headers}
                      setModal={setModal}
                      values={values}
                      setFieldValue={setFieldValue}
                      resetForm={resetForm}
                      setRawData={setRawData}
                      setEnableVoucher={setEnableVoucher}
                      setLoading={setLoading}
                      setShowSearchModal={setShowSearchModal}
                      modal={modal}
                      primerIdBodega={primerIdBodega}
                      productoSeleccionado={productoSeleccionado}
                      botonesDescripcion={botonesDescripcion}
                      setBotonesDescripcion={setBotonesDescripcion}
                      enviarModificado={enviarModificado}
                      setMensaje={setMensaje}
                      mensaje={"    "}
                      setProducto={setProducto}
                      handleSubmit={handleSubmit}
                      errors={errors}
                      setIdBodega={setIdBodega}
                    />
                  </div>

                  <div className="order-2 2xl:order-3 bg-primarioMira shadow-2xl rounded-lg 2xl:rounded-t-none 2xl:rounded-b-lg">
                    <DatagridItemsBodega
                      col={true}
                      data={currentRecords}
                      handleQuery={handleQuery}
                      addProduct={intermediario}
                      values={values}
                      isFormik={false}
                      type="facturacion"
                      query={query}
                      setQuery={setQuery}
                      label="Lista detallada de productos donde puede consultar y agregar productos a la factura."
                    />
                    <Pagination
                      nPages={nPages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      totalRecords={filterData?.length}
                      indexOfFirstRecord={indexOfFirstRecord}
                      indexOfLastRecord={indexOfLastRecord}
                    />
                  </div>
                  
                  <div className="order-3 2xl:order-2 bg-primarioMira shadow-2xl rounded-lg 2xl:rounded-b-none 2xl:rounded-t-lg border-b-0 2xl:border-b border-b-grisMira">
                    <ResumenProductos
                      productos={productos}
                      delProducto={delProducto}
                      updateProducto={updateProducto}
                      height={"2xl:h-[15rem]"}
                    />
                  </div>

                  <div className="order-last bg-primarioMira shadow-2xl rounded-lg 2xl:rounded-t-none 2xl:rounded-b-lg" ref={pagoRef}>
                    <Pago
                      setMensaje={setMensaje}
                      values={values}
                      setFieldValue={setFieldValue}
                      productos={productos}
                      setModal={setModal}
                      errors={errors}
                      touched={touched}
                      enableVoucher={enableVoucher}
                      centro={0}
                      validadorTarjeta={validadorTarjeta}
                      setValidadorTarjeta={setValidadorTarjeta}
                      botonesDescripcion={botonesDescripcion}
                    />
                    {
                      productos.length > 0 && (
                        <div className="px-6 pb-6">
                          <SubmitButton label={"Realizar factura"} handleClick={handleSubmit} values={values} errors={errors}/>
                        </div>
                      )
                    }
                  </div>
                </div>
              </Form>
              </div>
            );
          }}
        </Formik>
      </Container>
        </div>
    </Layout>
  );
};

const manager = function eventManager(fn) {
  let excecuting = false;
  return async () => {
      if(!excecuting){
          excecuting = true;
          await fn();
          setTimeout(() => {excecuting = false}, 15000);
      }
  }
}

const fomatearFormasPago = (
  efectivo,
  tarjeta,
  fecha,
  voucher,
  noBoleta,
  fechaBoleta
) => {
  let array = [];

  array[0] = {
    TipoTrans: 1,
    NoBoleta: "",
    IdBanco: 0,
    Valor: efectivo,
    Fecha: fecha,
  };

  array[1] = {
    TipoTrans: 8,
    NoBoleta: "",
    IdBanco: 0,
    Valor: tarjeta,
    Fecha: fecha,
  };

  if (voucher) {
    array[2] = {
      TipoTrans: 4,
      NoBoleta: noBoleta,
      IdBanco: 0,
      Valor: voucher,
      Fecha: fechaBoleta,
    };
  }

  return array;
};

export default Facturacion;
